import React from 'react';
import PropTypes from 'prop-types';

import Form from '@appComponents/ReduxFormControls';

const getA11yProps = (action) => ({
    onClick: action,
    role: 'button',
    tabIndex: 0,
    style: {cursor: 'pointer'},
});

const TimeField = ({
    input,
    label,
    radioOptions,
    marginInputProps = {},
    fixedInputProps = {},
    pastMode = false,
    pastDateTime = null,
    pastMargin = null,
    pastMarginText = null,
}) => {
    if (pastMode) {
        let marginText = '';

        if (undefined !== pastMargin && null !== pastMargin) {
            marginText = pastMarginText
                ? ` (${pastMargin} ${pastMarginText})`
                : ` (${pastMargin} minutes before the event start time)`;
        }

        return (
            <div>
                {/* eslint-disable-next-line jsx-a11y/label-has-for */}
                <label>{label}</label>
                <div className='input-container timefield-group'>
                    <div>
                        <span>{pastDateTime}</span><span>{marginText}</span>
                    </div>
                </div>
            </div>
        );
    }

    const selectedValue = input.value;

    const handleSelectOption = (opt) => {
        if (selectedValue !== opt.value) {
            input.onChange(opt.value);
        }
    };

    return (
        <div>
            {/* eslint-disable-next-line jsx-a11y/label-has-for */}
            <label>{label}</label>
            <div className='input-container timefield-group'>
                {radioOptions
                    .filter(opt => !opt.hidden)
                    .map((opt) => (
                        <div
                            className='timefield-row'
                            key={opt.id || opt.value}
                        >
                            <label htmlFor={`${input.name}_${opt.value}`} className='timefield-radio-label'>
                                <input
                                    name={input.name}
                                    type='radio'
                                    value={opt.value}
                                    checked={selectedValue === opt.value}
                                    onChange={() => input.onChange(opt.value)}
                                    id={`${input.name}_${opt.value}`}
                                    className='timefield-radio-input'
                                    onClick={e => e.stopPropagation()}
                                />
                                <span className='timefield-label-text'>{opt.label}</span>
                            </label>
                            {opt.name && (
                                <>
                                    <Form.FormField
                                        name={opt.name}
                                        type={opt.type}
                                        component={Form.ReduxInput}
                                        disabled={selectedValue !== opt.value}
                                        className={`timefield-input timefield-input-${opt.type}`}
                                        configuration={opt.configuration}
                                        onFocus={() => handleSelectOption(opt)}
                                        onClick={() => handleSelectOption(opt)}
                                        {...('date' === opt.type ? fixedInputProps : marginInputProps)}
                                        {...opt.inputProps}
                                    />
                                    {'number' === opt.type &&
                                        <span
                                            className='timefield-input-label'
                                            {...getA11yProps(() => handleSelectOption(opt))}
                                        >{opt.inputLabel}</span>
                                    }
                                </>
                            )}
                        </div>
                    ))}
            </div>
        </div>
    );
};

TimeField.propTypes = {
    input: PropTypes.object.isRequired,
    meta: PropTypes.object,
    label: PropTypes.node.isRequired,
    radioOptions: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        value: PropTypes.any.isRequired,
        label: PropTypes.node,
        type: PropTypes.string,
        inputLabel: PropTypes.node,
        inputProps: PropTypes.object,
    })).isRequired,
    marginInputProps: PropTypes.object,
    fixedInputProps: PropTypes.object,
    className: PropTypes.string,
    pastMode: PropTypes.bool,
    pastDateTime: PropTypes.string,
    pastMargin: PropTypes.number,
    pastMarginText: PropTypes.string,
};

export default TimeField;
